import React, { useContext, useState, useEffect, Fragment } from "react";
import { MsalContext } from "../../Contexts/MsalContext";
import { Theme } from '@mui/material/styles';
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import MonitoringCallInfoBodyDetail from "./MonitoringCallInfoBodyDetail";
import ClientSummary from "../ClientSummary";
import ActionSelector from "../../CallInfo/ActionSelector";
import { APIContext } from "../../Contexts/APIContext";

const styles = {
    root: {
        backgroundImage: 'call',
        color: 'black',
    },
    grid: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: (theme: Theme) => theme.palette.background.paper,
    },
    flex: {
        display: 'inline',
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
    recordDiv: {
        padding: (theme: Theme) => theme.spacing(1),
    },
    errorMessage: {
        color: 'red',
    },
    paper: {
        padding: (theme: Theme) => theme.spacing(1),
        width: '100%'
    }
}

interface IMonitoringCallInfoBody {
    id: string | null;
    systemId: string;
}

class RowObjectStruct {
    public name: string;
    public rows: object;
}

export default function MonitoringCallInfoBody(props: IMonitoringCallInfoBody) {
    const { isQA, isAdmin } = useContext(APIContext);
    const { msalFetch } = useContext(MsalContext);
    const [loaded, setLoaded] = useState(false);
    const [data, setData] = useState<RowObjectStruct[]>([]);
    const [value, setValue] = useState('0');
    const [errored, setErrored] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        msalFetch('api/MonitoringCallInfo/getCustomerProductInfo?systemPK=' + encodeURIComponent(props.id!))
            .then(response => response.json())
            .then(Data => {
                setData(Data);
                setLoaded(true);
            }).catch(httpResponse => {
                setErrored(true);
                setErrorMessage("Failed to load call details");
                setLoaded(false);
            });
    }

    const handleChange = (_, value) => setValue(value);

    return (
        errored ? (
            <Grid sx={styles.grid}>
                <Typography sx={styles.errorMessage}>{errorMessage}</Typography>
            </Grid>
        ) :
            data.length <= 0 ? (<React.Fragment />)
                :
                (loaded ?
                    (<Fragment>
                        <Tabs value={value} onChange={handleChange} textColor="secondary" scrollButtons variant="scrollable">
                            {data.map((data, i) => <Tab key={'key' + i.toString()} value={i.toString()} label={data.name === 'Notes' ? 'Agent Notes' : data.name} color="secondary" />)}
                            <Tab label="Call Notes" value={(data.length + 1).toString()} color="secondary"></Tab>
                            {(isQA || isAdmin) && <Tab label="Actions" value={(data.length + 2).toString()} color="secondary"></Tab>}
                        </Tabs>
                        {value <= (data.length).toString() ?
                            data.map((data, i) => value === i.toString() && <MonitoringCallInfoBodyDetail key={'cib' + data.name} row={data.rows} />)
                            :
                            <React.Fragment>
                                {value === (data.length + 1).toString() ?
                                    <ClientSummary systemId={props.systemId} callRefId={props.id} />
                                    :
                                    <ActionSelector systemPK={props.systemId} />
                                }
                            </React.Fragment>
                        }
                    </Fragment>
                    ) :
                    <Fragment />
                )
    );
}